/* raw layout hash: _subscription-tier-seat-licensing-layout:415a2bf6eb1385c401fddb40f7fa30dcc0d8d21df4d6396d2b39a682c9fc15f4 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_subscription-tier-seat-licensing-layout" — renders its page content through the router outlet.
export default function SubscriptionTierSeatLicensingLayout() {
  return <AppShell layoutName="_subscription-tier-seat-licensing-layout" menu={LAYOUT_MENUS['_subscription-tier-seat-licensing-layout']} />;
}
